import React, {useState} from 'react';
import InputSelect from "../../../components/Form/InputSelect";
import {Form} from "@unform/web";
import {Link} from "react-router-dom";
import CustomButton from "../../../components/Form/Button";
import {BiArrowBack} from "react-icons/bi";
import {toast} from "react-toastify";
import messageTypes from "../../../constants/MessagesTypes";
import QuotexCSV from "../../../components/QuotexCSV";
import IqOptionCSV from "../../../components/IqOptionCSV";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../../components/DivDiagonal";
import {TradingListPageHeader} from "../styles";
import {
    TradingNewWrapper,
    ContentArea,
    TradingNewFormWrap,
    TradingFormCard,
    StyledFormWrapper,
    ButtonContainer,
    ImportFieldsStack,
    FileUploadZone,
    FileUploadLabel,
    FileUploadBox,
    FileUploadPrompt,
    FileUploadHint,
} from "./styles";

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const nextBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

export default function ImportTrading() {
    const [fileCSV, setFileCSV] = useState(null);
    const [broker, setBroker] = useState(null);
    const [isSubmit, setSubmit] = useState(false);

    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    const { t } = useTranslation();

    async function handleSubmit() {
        if (!fileCSV || !broker) {
            toast.warning(messageTypes.REQUIRED_FIELDS);
            return;
        }

        setSubmit(true);
    }

    return (
        <>
            {isActiveSignature && (
                <TradingNewWrapper>
                    <DivDiagonal />
                    <ContentArea>
                        {!isSubmit && (
                            <>
                                <TradingListPageHeader>
                                    <h1>
                                        <i className="fas fa-file-import" aria-hidden="true"/>{' '}
                                        {t('traging_import_card_title')}
                                    </h1>
                                </TradingListPageHeader>
                                <TradingNewFormWrap>
                                    <TradingFormCard>
                                        <StyledFormWrapper>
                                            <Form onSubmit={handleSubmit}>
                                                <ImportFieldsStack>
                                                    <FileUploadZone>
                                                        <FileUploadLabel>
                                                            {t('strategy_btn_import_CSV')}
                                                        </FileUploadLabel>
                                                        <FileUploadBox>
                                                            <input
                                                                accept=".csv"
                                                                name="fileCSV"
                                                                onChange={(e) => {
                                                                    setFileCSV(e.target.files[0]);
                                                                }}
                                                                type="file"
                                                            />
                                                            <FileUploadPrompt>
                                                                {fileCSV
                                                                    ? fileCSV.name
                                                                    : t('traging_import_dropzone_prompt')}
                                                            </FileUploadPrompt>
                                                            <FileUploadHint>
                                                                {t('traging_import_csv_only')}
                                                            </FileUploadHint>
                                                        </FileUploadBox>
                                                    </FileUploadZone>
                                                    <InputSelect
                                                        type="file"
                                                        name="broker"
                                                        onChange={(e) => {
                                                            setBroker(e.target.value);
                                                        }}
                                                        label={t('traging_import_label_input_broker') + ' *'}
                                                        options={[
                                                            {key: 'EXNOVA', value: 'Exnova'},
                                                            {key: 'IQ_OPTION', value: 'IQ Option'},
                                                            {key: 'BROKER_10', value: 'Broker 10'},
                                                            {key: 'QUOTEX', value: 'Quotex'},
                                                        ]}
                                                    />
                                                </ImportFieldsStack>
                                                <ButtonContainer>
                                                    <Link to="/trading" style={{ textDecoration: 'none' }}>
                                                        <CustomButton
                                                            variant="outlined"
                                                            className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                                            startIcon={<BiArrowBack/>}
                                                            style={backBtnStyle}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                                                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                            }}
                                                        >
                                                            {t('btn_back')}
                                                        </CustomButton>
                                                    </Link>
                                                    <CustomButton
                                                        className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                                        type="submit"
                                                        style={nextBtnStyle}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                                        }}
                                                    >
                                                        {t('traging_import_btn_next')}
                                                    </CustomButton>
                                                </ButtonContainer>
                                            </Form>
                                        </StyledFormWrapper>
                                    </TradingFormCard>
                                </TradingNewFormWrap>
                            </>
                        )}
                        {isSubmit && (
                            <>
                                <TradingListPageHeader>
                                    <h1>
                                        <i className="fas fa-file-import" aria-hidden="true"/>{' '}
                                        {t('traging_import_card_title')}
                                    </h1>
                                </TradingListPageHeader>
                                {broker === 'QUOTEX' && <QuotexCSV fileCSV={fileCSV}/>}
                                {['IQ_OPTION', 'EXNOVA', 'BROKER_10'].includes(broker) && (
                                    <IqOptionCSV
                                        fileCSV={fileCSV}
                                        importBrokerSlug={
                                            broker === 'EXNOVA'
                                                ? 'exnova'
                                                : broker === 'BROKER_10'
                                                    ? 'broker10'
                                                    : 'iqoption'
                                        }
                                    />
                                )}
                            </>
                        )}
                    </ContentArea>
                </TradingNewWrapper>
            )}
        </>
    );
}
